 import React from 'react';
 import { Field } from 'react-final-form';
 import MultipleSelect from '../../../../components/RenderMultiSelectField';

 const LanguagesInput = ({choices}) => {
  const parseLanguagesToIdsArray = languages => languages.map(({id})=>id);
  const formatIdsToLanguagesArray = languagesIds => languagesIds.map(language => choices.find(({id})=>language===id))
  return (
  <Field
    component={MultipleSelect}
    name='languagesIDs'
    label='Select languages *'
    margin='none'
    options={choices}
    disableSelected={false}
    parse={parseLanguagesToIdsArray}
    format={formatIdsToLanguagesArray}
  />
)}

 export default LanguagesInput;
